module.exports = __webpack_public_path__ + "71342640bf9579e0f33a9ed407738f0b.png";